import { authHttp } from '../http'
import { errorHandler } from '../../../util/error.service'
import { CONFIG } from '../../../../config'

const { ENVIROMENT } = CONFIG

const PatrimonioOwnerHttp = {
  baseURL: `${CONFIG[ENVIROMENT]['MAIN_END_POINT']}/patrimonio`,

  async fetchOwners() {
    try {
      const url = this.baseURL + '/patrimonio-owner'
      const response = await authHttp().get(url)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async fetchOwnersByUserId(userId) {
    try {
      const url = this.baseURL + `/patrimonio-owner/${userId}`
      const response = await authHttp().get(url)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async saveOwner(owner) {
    try {
      const url = this.baseURL + '/patrimonio-owner'
      const response = await authHttp().post(url, owner)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async fetchAssocUserPatrimonioOwner(userId) {
    try {
      const url = this.baseURL + '/assoc-user-patrimonio-owner/' + userId
      const response = await authHttp().get(url)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },
  async assocUserPatrimonioOwnerHandler(userId, patrimonioOwnerId) {
    try {
      const url = this.baseURL + '/assoc-user-patrimonio-owner'
      const response = await authHttp().post(url, {
        user_id: userId,
        patrimonio_owner_id: patrimonioOwnerId,
      })
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },
}

export default PatrimonioOwnerHttp
